export const _checkMenuOptionsActive = (path) => {
  const pathName = window.location.pathname.split("/")[3];
  if (path == "/ecourse/activity" && pathName == "transaction") {
    return "link-active-blue";
  } else {
    return path == window.location.pathname && "link-active-blue";
  }
};

export const _isShowSponsoreChannel = (ecourseItem) => {
  return ecourseItem.sponsorship || ecourseItem.channel;
};

export const _sponsoreChannelName = (ecourseItem) => {
  var nameStr = "";
  if (ecourseItem.channel) {
    nameStr = ecourseItem.channel.name;
  } else if (ecourseItem.sponsorship) {
    nameStr = ecourseItem.sponsorship.name;
  }
  return nameStr;
};

export const _sponsoreChannelCategory = (ecourseItem) => {
  var categoryStr = "Dipersembahkan oleh";
  if (ecourseItem.channel) {
    categoryStr = ecourseItem.channel.channel_sponsorship_name;
  }
  return categoryStr;
};

export const _sponsoreChannelLogo = (ecourseItem) => {
  var logoStr = "";
  if (ecourseItem.channel) {
    logoStr = ecourseItem.channel.logo;
  } else if (ecourseItem.sponsorship) {
    logoStr = ecourseItem.sponsorship.logo;
  }
  return logoStr;
};

export const _formattedSpesialisasi = (ecourseItem) => {
  return ecourseItem.map((item) => item["name"]).join(", ");
};

export const _checkPaidList = (paid, status) => {
  return paid == true && status == "";
};

export const _checkStatusRegister = (status) => {
  return status !== "";
};

export const _checkExpDate = (exp) => {
  return exp !== "";
};
export const _checkNotExpDate = (exp) => {
  return exp == "";
};

export const _checkCardFaqShow = (data) => {
  return data == "show";
};

export const _checkCardFaqHide = (data) => {
  return data == "hide";
};

export const _checkStatusTransaction = (status, params) => {
  if (status == "" && params == "all") {
    return "button-filter-active";
  } else {
    return status == params && "button-filter-active";
  }
};

export const _formattedStatusTransaction = (status) => {
  if (status === "success") {
    return "Pendaftaran Berhasil";
  } else if (status === "pending") {
    return "Menunggu Pembayaran";
  } else if (status === "failed") {
    return "Transaksi Gagal";
  }
};

export const _renderCssStatusTransaction = (status) => {
  if (status === "success") {
    return "container-header-success";
  } else if (status === "pending") {
    return "container-header-pending";
  } else if (status === "failed") {
    return "container-header-failed";
  }
};

export const _checkStatusTransactionFail = (status) => {
  return status === "failed";
};

export const _checkStatusTransactionSucess = (status) => {
  return status === "success";
};

export const _checkStatusTransactionPending = (status) => {
  return status === "pending";
};

export const _checkStatusTransactionSuccessOrPending = (status) => {
  return status === "success" || status === "pending";
};

export const _checkEmptyData = (data) => {
  return data.length === 0;
};

export const _indexModule = (index) => {
  return index + 1;
};

export const _checkPaginationNext = (item) => {
  return item.length >= 10;
};

export const _checkPreviousPage = (page) => {
  return page > 1;
};

export const _checkPoint = (point) => {
  return point > 0;
};

export const _checkPassedEcourse = (userStatus) => {
  return userStatus == "passed";
};

export const _checkModulProgress = (userStatus) => {
  if(userStatus == "enrolled") {
    return true
  }
};

export const _checkInitialModulProgress = (userStatus) => {
  if(userStatus == "onprogress") {
    return true
  }
}
export const checkUserPassedPostTest = (module, userStatus) => {
  if(module.user_status == 'passed' && userStatus != '') {
    return true
  }
}

export const checkUserFailedPostTest = (module, userStatus) => {
  if(module.user_status == 'failed' && userStatus != '') {
    return true
  }
}

export const checkUserStatusPostTest = (module, userStatus) => {
  if(module.user_status == '' && userStatus != '') {
    return true
  }
}

export const checkIsUserEnrolled = (userStatus) => {
  return userStatus == '';
}

export const getIndexModule = (listTopik, module) =>{
  for (let index = 0; index < listTopik.length; index++) {
    if (module.id == listTopik[index].id) {
      return index + 1;
    }
  }
  return 0;
}

export const _getModuleEcourseTestStatus = (module) => {
  return module.user_status == "passed" ? "passed" : "not_passed";
}

export const _isVideoContent = (type) => {
  return type == "video";
}

export const _isArticleContent = (type) => {
  return type == "article";
}